import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Masis from '../../img/Agenda/Masis.png';
import Syngenta from '../../img/Agenda/Syngenta.png';
import Munoz from '../../img/Agenda/Munoz.png';
import FiscalNote from '../../img/Agenda/FiscalNote.png';
import Tua from '../../img/Agenda/Tua.png';
import Agrawal from '../../img/Agenda/Agrawal.png';


export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
              {
                  id: 1,
                  time: '10:10',
                  photo: Masis,
                  name: 'Serg Masis',
                  position: 'Climate & Agronomic Data Scientist',
                  ln: 'https://www.linkedin.com/in/smasis/',
                  logo: Syngenta,
                  title: 'Roadmap for your Data science Journey: Myths and Tips',
                  abstract: `This session aims to dispel many of the myths surrounding what a data scientist is, what skills are needed to become one, and where to start. Then, offer many tips on practicing those skills, applying to jobs, and continuing growth and learning on the job. I will present my own story and examples from my career.`,
              },
              {
                  id: 2,
                  time: '10:50',
                  photo: Munoz,
                  name: 'Daniel Munoz',
                  position: 'Machine Learning Engineer',
                  ln: 'https://www.linkedin.com/in/munozai',
                  logo: FiscalNote,
                  title: 'Breaking into AI',
                  abstract: `In this talk I will discuss how to break into the AI industry from the perspective of a beginner (students, and professionals transitioning roles). The talk will mostly be centered around breaking into the industry in the US however the general pieces of advise should be applicable in multiple places. 

                  By the end of the talk the goal is to provide the listeners with an actionable plan that they can use to successfully break into the industry.`,
              },
              {
                id: 3,
                time: '11:30',
                photo: Tua,
                name: 'Benjamin Tua',
                position: 'Data Science and Analytics Consultant',
                ln: 'https://www.linkedin.com/in/benjamin-tua-48882854/',
                companyName: 'Oracle',
                title: 'Data Wrangling: SQL for Data Analytics',
                abstract: `Data analytics is changing the face of business in nearly every industry. Data analysts are now able to collect and organize vast quantities of information from a variety of sources, giving businesses the opportunity to use data as an effective decision-making tool. 
                SQL, or Structured Query Language, is a programming language specifically designed for managing data in relational database management systems (RDBMS). Using data, insights that would have been impossible to derive years ago can now be found with just a few lines of computer code and user-friendly interfaces that leverage drag and drop abilities for non-technical users. With SQL business are now able to analyze their data both structured and unstructured in a faster and easier way.
                Having worked in various industries I have seen and taken part in the digital data transformation process for various businesses both in Kenya and USA through design and development of data products using various tools including Oracle Analytics, Microsoft BI Suite, PowerBI, Tableau among others.`,
              },
              {
                id: 4,
                time: '12:10',
                photo: Agrawal,
                name: 'Kshitij  Agrawal',
                position: 'Senior Research Scientist',
                ln: 'https://www.linkedin.com/in/agrawalkshitij/',
                companyName: 'Swiggy',
                title: 'Automatic Document Processing in the Age of AI',
                abstract: `In this day and age we are constantly using our smartphone cameras to document every stage of our life, every interesting event that we come across. Similarly, organizations have adopted to using the smartphone camera to document work, verify progress and mark an issue as resolved in the real world. From insurance to banking to medical applications - computer vision is being increasingly applied to accelerate decisions and reduce wait times. 

                In this session we will look at the field of document processing using computer vision, the various stages of processing and different tasks that exist in document processing for business applications.`,
              },
            ],
        }
      }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">Agenda</h3>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">June 28 09:00 - 19:30</p>
                    <p className="agenda_day">Beginner Track</p>
                    <VideoPresent speakers={this.state.list}/>
                    <a className='full_agenda_btn' href='https://geekle.us/schedule/datascience' target='_blank' rel="noreferrer">SHOW FULL AGENDA</a>
                </div>
            </div>
        );
    }
};